export default __webpack_public_path__ + "static/media/inicial.f8681ca5.png";